export enum MutationTypes {
  JOBPOSTING_STEP_LOADING = "JOBPOSTING_STEP_LOADING",
  JOBPOSTING_STEP_LOADED = "JOBPOSTING_STEP_LOADED",
  JOBPOSTING_LOADING = "JOBPOSTING_LOADING",
  JOBPOSTING_LOADED = "JOBPOSTING_LOADED",
  CLEAR_CURRENT_JOBPOSTING = "CLEAR_CURRENT_JOBPOSTING",
  ADD_EMPLOYEE_LOADING = "ADD_EMPLOYEE_LOADING",
  ADD_EMPLOYEE_LOADED = "ADD_EMPLOYEE_LOADED",
  DELETE_EMPLOYEE_LOADING = "DELETE_EMPLOYEE_LOADING",
  DELETE_EMPLOYEE_LOADED = "DELETE_EMPLOYEE_LOADED",
  EMPLOYEES_LOADING = "EMPLOYEES_LOADING",
  EMPLOYEES_LOADED = "EMPLOYEES_LOADED",
  DELETE_JOBPOSTING_LOADING = "DELETE_JOBPOSTING_LOADING",
  DELETE_JOBPOSTING_LOADED = "DELETE_JOBPOSTING_LOADED",
}
